import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContentPasteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"content_paste"}/>
}
